export enum CoordinateSystemType {
  Global,
  Manual,
  SiteCoordinates,
  Custom,
  NotSelected ,
}
